/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import {
  Box,
  CardMedia,
  Tab,
  Tabs,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useEffect, useState } from "react";
import { MOBLIE_VIEW_WIDTH } from "../../constants/constants";
import { Scrollbar, Keyboard, Autoplay, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { useRef } from "react";
import AddCircularIcon from "./AddCircularIcon";
import Markdown from "markdown-to-jsx";
const sideParent = css`
  display: flex;
  flex-direction: column;
  height: 90vh;
  postion: relative;
  margin-top: 20px;
  .MuiTabs-flexContainer {
    flex-direction: row;
    justify-content: flex-end;
  }
`;

const imgText = css`
  color: white;
  position: absolute;
  margin-top: 10%;
  margin-left: 5%;
  z-index: 1;
`;

const sideImage = css`
  height: 85%;
  object-fit: cover !important;
`;

const text = css`
  position: absolute;
  top: 120%;
  left: 10%;
`;

const useStyles = makeStyles({
  descriptionText: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "450px",
  },
});

export default function TabViewCarousel({ tabViewCarouselData }) {
  const [images, setImages] = useState([]);
  const [buttons, setButtons] = useState([]);
  const [headings, setHeadings] = useState([]);
  const [descriptions, setDescriptions] = useState([]);
  const [link, setLink] = useState({
    buttonLink: [],
    buttonText: [],
    isExternalLink: [],
  });
  const [value, setValue] = useState(0);
  const [sliderIndex, setSliderIndex] = useState(0);
  const containerRef = React.useRef(null);
  const mobileMatches = useMediaQuery(MOBLIE_VIEW_WIDTH);
  const myRef = useRef();
  const styles = useStyles();

  useEffect(() => {
    const main = {
      image: [],
      button: [],
      buttonText: [],
      buttonLink: [],
      isExternalLinks: [],
      heading: [],
      description: [],
    };
    tabViewCarouselData.map((item) => {
      if (item?.media?.data?.attributes?.url) {
        if (item?.isExternalLink) {
          main.image.push(item?.isExternalLink);
        } else {
          main.image.push(
            process.env.REACT_APP_BASEURL + item?.media?.data?.attributes?.url
          );
        }
      }
      main.button.push(item?.title);
      main.buttonText.push(item?.buttonText);
      main.buttonLink.push(item?.buttonLink);
      main.isExternalLinks.push(item?.isExternalLink);
      main.heading.push(item?.heading);
      main.description.push(item?.description);
    });
    setImages([...main.image]);
    setButtons([...main.button]);
    setLink((prevState) => ({
      ...prevState,
      buttonText: main.buttonText,
      buttonLink: main.buttonLink,
      isExternalLinks: main.isExternalLinks,
    }));
    setHeadings([...main.heading]);
    setDescriptions([...main.description]);
  }, [tabViewCarouselData]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleClick = (val = value) => {
    if (link.isExternalLinks[val]) {
      window.open(link.buttonLink[val]);
    } else {
      window.location = link.buttonLink[val];
    }
  };

  const sliderArray = images.map((item) => (
    <CardMedia
      component="img"
      key={item.toString()}
      css={sideImage}
      image={item}
      alt="No Image Present"
    ></CardMedia>
  ));

  const handleSlideChange = (swiperCore) => {
    setSliderIndex(swiperCore.realIndex);
  };

  return (
    <Box ref={containerRef}>
      {mobileMatches ? (
        <div css={sideParent}>
          <Tabs value={value} onChange={handleChange}>
            {buttons.map((item, index) => (
              <Tab
                key={index}
                style={{ color: "white", fontSize: "16px" }}
                label={item}
              ></Tab>
            ))}
          </Tabs>
          {sliderArray[value]}
          <Box css={text}>
            <Typography variant="h3" p={2}>
              {headings[value]}
            </Typography>
            <Typography
              className={styles.descriptionText}
              variant="body1"
              p={2}
            >
              <Markdown>{descriptions[value] || ""}</Markdown>
            </Typography>
          </Box>
          {link.buttonText[value] && (
            <AddCircularIcon
              translateValue={"translate(0px, -60px)"}
              handleClick={() => handleClick(value)}
              buttonText={link.buttonText[value]}
            />
          )}
        </div>
      ) : (
        <>
          <Swiper
            modules={[Scrollbar, Keyboard, Autoplay, Pagination]}
            grabCursor
            autoHeight={true}
            keyboard={{ enabled: true }}
            spaceBetween={0}
            pagination={{
              el: ".my-custom-pagination-div",
              clickable: true,
              type: "bullets",
            }}
            onSlideChange={handleSlideChange}
            ref={myRef}
          >
            {tabViewCarouselData?.map((item, index) => {
              return (
                <SwiperSlide key={index}>
                  <Box css={imgText}>
                    <Typography p={1} variant="h3">
                      {item.title}
                    </Typography>
                  </Box>
                  {item.media?.data?.attributes?.url && (
                    <CardMedia
                      component="img"
                      image={
                        process.env.REACT_APP_BASEURL +
                        item.media?.data?.attributes?.url
                      }
                      style={{ minHeight: "200px" }}
                    ></CardMedia>
                  )}
                </SwiperSlide>
              );
            })}
          </Swiper>
          <div className="my-custom-pagination-div" />
          <Box p={2} pt={2}>
            <Typography variant="h4" p={2}>
              {headings[sliderIndex]}
            </Typography>
            <Typography
              className={styles.descriptionText}
              variant="body1"
              p={1.5}
            >
              <Markdown>{descriptions[sliderIndex] || ""}</Markdown>
            </Typography>
            <AddCircularIcon
              translateValue={"translate(11px, 10px)"}
              handleClick={() => handleClick(sliderIndex)}
              buttonText={link.buttonText[sliderIndex]}
            />
          </Box>
        </>
      )}
    </Box>
  );
}
